// extracted by mini-css-extract-plugin
export default {"mainButton":"MainButton_mainButton__bM5c7","buttonText":"MainButton_buttonText__6sKhk","icon":"MainButton_icon__xxl73"};